module.exports = __webpack_public_path__ + "media/images/icon-close-49a9b0be88f3504aa2141c7e5b2df56d.svg";